import React, { useState } from 'react';
import Switch from 'react-switch';
import { ModalCauHinhTatToan } from './ModalCauHinhTatToan';

export const SwitchCauHinhTatToan = ({ checked, onChange }) => {
    const [showModal, setShowModal] = useState(false);

    const handleSwitchChange = (isChecked) => {
        if (isChecked) {
            setShowModal(true);
        } else {
            onChange(false);
        }
    };

    const handleConfirm = () => {
        onChange(true);
        setShowModal(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <Switch
                onChange={handleSwitchChange}
                checked={checked}
                onColor="#28D094"
                offColor="#d9534f"
                height={24}
                width={50}
            />
            {showModal && (
                <ModalCauHinhTatToan
                    show={showModal}
                    onHide={handleCloseModal}
                    onConfirm={handleConfirm}
                />
            )}
        </>
    );
};